export const STEP_PASSWORD_URL = '/onboarding/step/welcome';
export const STEP_ACCOUNT_URL = '/onboarding/step/account';
export const STEP_BRANDING_URL = '/onboarding/step/branding';
export const STEP_PAYMENT_URL = '/onboarding/step/means-of-payments';
export const STEP_REVIEW_URL = '/onboarding/step/review';
